import * as React from "react";
import { MemoriaBase } from "./MemoriaBase";
import { CTE_CONFIG } from "./memoriaConfigs";

export const MemoriaCte = () => <MemoriaBase config={CTE_CONFIG} />;

export default MemoriaCte;
